<template>
  <span
    class="absolute left-1/2 -bottom-1.5 -translate-x-1/2 rounded-full bg-danger-700 px-1 text-[10px] font-bold leading-[14px] text-text-primary ring-2 pointer-events-none"
  >Beta</span>
</template>
